import { getAxiosClient } from './common';

const axios = getAxiosClient();

export type DeployInfo = {
  /** GitHub username that dispatched the Deploy Preview workflow. */
  actor: string;
  /** What the deployer said they were testing. */
  reason: string;
  /** Team color for the header badge: Silver | Blue | Green | Orange. */
  color: string;
  /** ISO-8601 UTC timestamp of the deploy. */
  deployedAt: string;
  /** Deployed ref, `<branch>-<short sha>` on preview deploys. */
  gitsha?: string;
};

/**
 * Read preview-deploy ownership from the api's public GET /tick.
 * Returns null when the api reports no deploy metadata (any non-preview env) or the call fails —
 * the header badge is decorative and must never surface an error.
 */
export async function fetchDeployInfo(): Promise<DeployInfo | null> {
  try {
    const { data } = await axios({ method: 'GET', url: '/tick' });
    const deploy = data?.deploy;

    if (!deploy || typeof deploy.actor !== 'string') return null;

    return {
      actor: deploy.actor,
      reason: typeof deploy.reason === 'string' ? deploy.reason : '',
      color: typeof deploy.color === 'string' ? deploy.color : 'Silver',
      deployedAt: typeof deploy.deployedAt === 'string' ? deploy.deployedAt : '',
      gitsha: typeof data.gitsha === 'string' ? data.gitsha : undefined,
    };
  } catch {
    return null;
  }
}
